import { Button, ButtonGroup, Dialog, Icon } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import {default as UUID} from "node-uuid";
import { ID } from "@libs/interfaces/layouts";
import DialogRight from "./DialogRight";
import GalleryDialog from "./GalleryDialog";
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated";
import { getAnimateDelay } from "src/modules/pe-landing-module/views/utils/getAnimateDelay";
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle";

 
export const Gallery = ({data, itemWidth}:any): JSX.Element => {
    const [isOpen, setIsOpen] = useState( false )
    const [i, setI] = useState(0)
    const to = (i:number) => {
        setI(i)
        setIsOpen( true )
    }
    return <>
        <div className="gallery">
        {
            Array.isArray(data)
                ?
                data.map( (url:URL, i:number) => {
                    return <GalleryItem 
                        i={i} 
                        url={url} 
                        key={url.toString()} 
                        galleryId={UUID.v4()} 
                        gallery={ data } 
                        width={ itemWidth }
                        to={to} 
                    />
                })
                :
                null
        }
        </div>
        <GalleryDialog
            i={ i }
            data={ data }
            setI={ to }
            isOpen={ isOpen }
            setIsOpen={ setIsOpen }
        />
    </>
}



interface IGalleryItemProps {
    i: number
    url: URL | string
    width?:number
    height?: number
    type?: "image" | "div" | "span"
    galleryId: ID
    gallery?: any[]
    to?: (i:number) => void
    animated?: ANIMATED_STYLE[]
    animated_delay?: ANIMATE_DELAY | string | number
}
export const GalleryItem = (
{
    i, 
    url="", 
    galleryId,
    gallery, 
    type, 
    width,
    height,
    to,
    ...props
}: IGalleryItemProps ) :JSX.Element => {
    const [isOpen, setIsOpen] = useState(false)
    const onOpen = () : void => {
        if(url)  {
            !gallery ? setIsOpen(!isOpen) : to ? to(i) : <></>
        } 
    } 
 
    const _animated_delay = getAnimateDelay( props.animated_delay, i)
    const ref = useRef(null)
    useAnimated( ref, _animated_delay )
    const animate   = useAnimatedStyle(props, i)

    let thumbnail : JSX.Element
    switch(type) {        
        case "image" :
            thumbnail = <div className="position-relative"> 
            <img 
                src={ url.toString() } 
                className={`thumbnail gallery-item pointer ${animate} `} 
                style={{ width, height }} 
                onClick={ onOpen }
                alt=""
                ref={ref}
            />
            </div>
            break
        case "span": 
            thumbnail = <span 
                className={`thumbnail gallery-item pointer ${animate} `} 
                style={{backgroundImage: `url(${ url })`, width, height }} 
                onClick={onOpen}
                ref={ref}
            />
            break
        case "div":
        default:
            thumbnail = <div 
                className={`thumbnail gallery-item pointer ${animate} `} 
                style={{ backgroundImage: `url(${ url })`, width, height }} 
                onClick={onOpen}
                ref={ref}
            />
            break
    }
    return <>
        { thumbnail }
        <Dialog
            isOpen={isOpen}
            onClose={onOpen}
            className="large flex-centered transparent"
        >
            <div className=" position-relative gallery-dialog"> 
                <img 
                    src={ url.toString() } 
                    alt="" 
                    style={{ maxHeight:"90vh", width: "100%", maxWidth:800 }} 
                />
                <div className="position-absolute top right m-2">
                    <Button onClick={onOpen} icon="cross"></Button>
                </div>            
            </div>
        </Dialog>
    </>
}